import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { CreateUpdateDistrictDataEntity } from './CreateUpdateDistrictDataEntity'

export class CreateUpdateDistrictEntity {
  region?: RegionMiniEntity
  districts?: Array<CreateUpdateDistrictDataEntity>
}
